export default __webpack_public_path__ + "static/years_bubble-0fed343d5966b6a04b5c8440319323f1.png";